export const UxConstants = {
    secretMask: "*****"
}
